module.exports = __webpack_public_path__ + "static/img/IMG_20150310_165344.c2793ccf.jpg";